import { RootState } from "@store";
import { useSelector } from "react-redux";

export const useSavedSettings = () => {
  const savedSettings = useSelector(
    (state: RootState) => state.savedMinerSettings.savedSettings
  );

  return savedSettings;
};
